export default __webpack_public_path__ + "static/staff-lockers-199ed3bf633f518f33923a0b76532db1.jpg";